export const rejectError = (reason) => {
  let message = reason.response ? `Unexpected error ${reason.response.status}` : 'Unexpected error';
  if (reason.response.data && reason.response.data.error) {
    // eslint-disable-next-line prefer-destructuring
    message = reason.response.data.error.message;
  }
  return Promise.reject(message);
};

export const rejectErrorApi = (result) => {
  let message = 'Unexpected error';
  if (result.data && result.data.error) {
    // eslint-disable-next-line prefer-destructuring
    message = result.data.error.message;
  }
  return Promise.reject(message);
};
